import Mutations from '../../odata/mutations';

export default { ...new Mutations('competency'), ...new Mutations('competencies') };
